import LearnPageLayout from "@/components/LearnPageLayout";
import { doesInsuranceCoverSaint } from "./learnDataDoesInsuranceCoverSaint";

/**
 * Static route wrapper for /learn/does-insurance-cover-saint-tms.
 */
const DoesInsuranceCoverSaintPage = () => (
  <LearnPageLayout
    title={doesInsuranceCoverSaint.title}
    description={doesInsuranceCoverSaint.description}
    canonical={doesInsuranceCoverSaint.canonical}
    h1={doesInsuranceCoverSaint.h1}
    breadcrumbLabel={doesInsuranceCoverSaint.breadcrumbLabel}
    crumbs={doesInsuranceCoverSaint.crumbs}
    shortAnswer={doesInsuranceCoverSaint.shortAnswer}
    keyTakeaways={doesInsuranceCoverSaint.keyTakeaways}
    sections={doesInsuranceCoverSaint.sections}
    faqs={doesInsuranceCoverSaint.faqs}
    sources={doesInsuranceCoverSaint.sources}
    schemaJson={doesInsuranceCoverSaint.schemaJson}
    relatedLinks={doesInsuranceCoverSaint.relatedLinks}
    reviewBlock={doesInsuranceCoverSaint.reviewBlock}
  />
);

export default DoesInsuranceCoverSaintPage;
